// @flow

import React, { type ComponentType } from 'react';
import PdbInfoComponent from './pdbInfo';

/* eslint-disable react/require-default-props */

export type OwnProps = {|
  show_motor_specs: boolean,
  show_occasions?: boolean,
  is_top10?: boolean,
  renderOccasions?: ?Function,
|};

export type Props = OwnProps;

const PdbInfo: ComponentType<Props> = ({
  show_motor_specs,
  show_occasions = false,
  is_top10 = false,
  renderOccasions,
}: Props) => (
  <PdbInfoComponent
    showMotorSpecs={show_motor_specs}
    showOccasions={show_occasions}
    hasRibbon={is_top10}
    renderOccasions={renderOccasions}
  />
);

export default PdbInfo;
